<template>
    <div class="row">
        <div class="col-sm-8 col-sm-offset-2" v-if="tagType == 'order'">
            <div id="qrCodesX2">
                <div v-if="printTagOn" id="qrRenderX2" style="text-align: left; padding-left: 2px; padding-right: 100px; padding-top: 180px; padding-bottom: 150px;">
                    <div id="renderDiv">
                        <div  id="qrGen">
                            <canvas id="genCanvas"></canvas>
                            {{ renderQrCode('genCanvas', tagData.order_no) }}
                        </div>
                    </div>
                    <div style="margin-top: 5px; text-align: left; font: 12pt Helvetica; line-height: 1;">
                        <span><strong>{{ tagData.order_no }}</strong></span>
                    </div>
                    <div style="margin-right: 80px; text-align: left; font: 9pt Helvetica; line-height: 1.5;">
                        <span style="font-size: 10pt !important;"><strong>{{ tagData.client_name }}</strong></span><br>
                        <span style="font-size: 10pt !important;"><strong>{{ tagData.contact_person }}</strong></span><br>
                        <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>{{ tagData.address }}</strong></span><br>
                        <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>{{ tagData.city }}</strong></span><br>
                        <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>{{ tagData.province }}</strong></span><br>
                        <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>{{ tagData.postal_code }}</strong></span><br>
                        <span style="word-wrap: break-word;  overflow-wrap: break-word;"><strong>Tel: {{ tagData.contact_no }}</strong></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as html2pdf from "../../../plugins/html2pdf/html2pdf.bundle.min";
import QRCode from 'qrcode'
import _ from 'lodash';
let htmlWorker = null;
export default {
    data: () => ({
        printTagOn: false,
        renderCount: 0,
        tagType: "",
        tagData: {},
        printJob: []
    }),
    methods: {
        printTag: function (obj) {
            this.$eventHub.$emit('setBusyPrinting', true);
            _.forEach(obj, function (value, key) {
                obj[key]['printed'] = false;
            })
            this.printJob = obj;
            this.handlePrintJob();
        },
        handlePrintJob() {
            let el = this;
            let unfinishedIndex = _.findIndex(this.printJob, function (o) { return o.printed == false; });
            if (unfinishedIndex > -1) {
                //there are unfinished print jobs
                if (this.printJob[unfinishedIndex].type == "order") {
                    this.tagData['order_no'] = this.printJob[unfinishedIndex].order_no;
                    this.tagData['tracking_src'] = this.printJob[unfinishedIndex].tracking_src;
                    this.tagData['address'] = this.printJob[unfinishedIndex].address;
                    this.tagData['city'] = this.printJob[unfinishedIndex].city;
                    this.tagData['province'] = this.printJob[unfinishedIndex].province;
                    this.tagData['postal_code'] = this.printJob[unfinishedIndex].postal_code;
                    this.tagData['contact_person'] = this.printJob[unfinishedIndex].contact_person;
                    this.tagData['contact_no'] = this.printJob[unfinishedIndex].contact_no;
                    this.tagData['client_name'] = this.printJob[unfinishedIndex].client_name;
                    this.tagType = this.printJob[unfinishedIndex].type;
                }
                //Render tag
                this.printTagOn = true;

                this.$nextTick(() => {
                    let pageFormat =   [140, 100]; //[50, 60];
                    let opt = {
                        margin: [0, 0, 0, 0],
                        filename: 'test.pdf',
                        image: { type: 'jpeg', quality: 1 },
                        html2canvas: { scale: 1 },
                        pagebreak: { mode: 'avoid-all' },
                        jsPDF: { unit: 'mm', format: pageFormat, orientation: 'portrait' }
                    };
                    setTimeout(function () {
                        let element = document.getElementById('qrRenderX2');
                        htmlWorker = html2pdf();
                        htmlWorker.set(opt).from(element).outputImg('datauristring').then(function (pdfAsString) {
                            el.pushToPrinter(pdfAsString, unfinishedIndex, el.tagType);
                        });
                    }, 350);
                });
            } else {
                this.$eventHub.$emit('setBusyPrinting', false);
            }
        },
        pushToPrinter: function (base64, unfinishedIndex, type) {
            this.printTagOn = false;
            window.axios.post('api/orders/print_tags', { file: base64, type: type })
            .then(() => {
                this.printJob[unfinishedIndex].printed = true;
                this.handlePrintJob();
            })
            .catch(e => {
                //eslint-disable-next-line
                console.log(e);
            });
        },
        renderQrCode(element, qrStr) {
            setTimeout(function () {
                let canvas = document.getElementById(element);
                QRCode.toCanvas(canvas, qrStr, { errorCorrectionLevel: 'L', width: 125, margin: 1 }, function (error) {
                    //eslint-disable-next-line
                    if (error) console.error(error);
                });
            }, 150);
        }
    },
    created: function () {
        this.$eventHub.$on('printTag', this.printTag);
    },
    beforeDestroy: function () {
        htmlWorker = null;
        this.$eventHub.$off('printTag');
    }
};
</script>
<style lang="scss" scoped>
#renderDiv {
    display: inline !important;
    margin-top: 8px;
}
.rotate {
    transform: rotate(-90deg);
    /* Legacy vendor prefixes that you probably don't need... */
    /* Safari */
    -webkit-transform: rotate(-90deg);
    /* Firefox */
    -moz-transform: rotate(-90deg);
    /* IE */
    -ms-transform: rotate(-90deg);
    /* Opera */
    -o-transform: rotate(-90deg);
}
</style>